import { PayloadAction } from '@reduxjs/toolkit';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';
import { getQuoteLineOrThrow } from '../utilities/action-guards';
import { QuoteLineParams } from './types';

export function quoteLineInfoToggled(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<QuoteLineParams>,
) {
  const quoteLine = getQuoteLineOrThrow(state, action.payload.quoteLineUuid);

  quoteLine.isInfoVisible = !quoteLine.isInfoVisible;
}
